import { trigger, transition, query, style, stagger, animate, keyframes } from "@angular/animations";

export const listAnimation = trigger('listAnimation', [
    transition('* => *', [
      query(':enter', [
        style({ transform: 'translateY(-50px)', opacity: 0 }),
        stagger('.2s', [
          animate('0.75s cubic-bezier(.8, -0.6, 0.2, 1.5)', keyframes([
            style({ transform: 'translateY(0)', opacity: 1 })
          ]))
        ])
      ], { optional: true }),
  
      query(':leave', [
        stagger('150ms', [
          animate('.7s cubic-bezier(.8, -0.6, 0.2, 1.5)', keyframes([
            style({
              transform: 'scale(0.5)', opacity: 0,
              height: '0px', margin: '0px'
            })
          ]))
        ])
      ], { optional: true })
    ])
  ]);
  